import * as React from 'react'
import { Button } from 'antd'

interface Props {
  isBatchClicked: boolean
  totalCountedQuantity: number | null
  totalExpectedQuantity: number | null
  toggleIsBatchClicked: () => void
}

export const BatchStatusToggleTd = (props: Props) => {
  const { isBatchClicked, toggleIsBatchClicked, totalCountedQuantity, totalExpectedQuantity } =
    props

  const className =
    totalCountedQuantity === totalExpectedQuantity && totalCountedQuantity !== 0
      ? 'text-success'
      : 'text-danger'

  return (
    <td
      style={{
        width: '5em',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
      className={className}
    >
      <Button
        className='mr-2'
        icon={isBatchClicked ? 'minus' : 'plus'}
        size='small'
        onClick={toggleIsBatchClicked}
      />

      {`${totalCountedQuantity} / ${totalExpectedQuantity}`}
    </td>
  )
}
